<div class="news-feed-v2-item">
    <ng-content></ng-content>
</div>
